import { defineStore } from "pinia";
import type { TUser } from "@/interfaces/app";

type TAppStoreState = {
  _user: TUser | null;
};

export const useAppStore = defineStore("appStore", {
  state: () =>
    ({
      _user: null,
    }) as TAppStoreState,
  getters: {
    user: (state) => state._user,
    subscription: (state) => state._user?.subscription,
    isLimitReached: (state) => {
      const subscription = state._user?.subscription;
      if (!subscription || typeof subscription !== "object") return false;

      const used = subscription.collections_used_current_cycle ?? 0;
      const limit = subscription.collections_limit_per_month ?? 0;

      return limit > 0 && used >= limit;
    },
  },
  actions: {
    // Mutations
    setUser(user: TUser | null) {
      this._user = user;
    },
    async logout() {
      const $router = useRouter();
      $router.push({
        path: "/logout",
      });
    },
  },
});

type UseNullStore = ReturnType<typeof defineStore>;
type NullStore = ReturnType<UseNullStore>;
type AppStoreNoSGA = ReturnType<typeof useAppStore>;
export type TAppStore = Omit<AppStoreNoSGA, keyof NullStore>;
